export const lang = {
  Home: {
    name: "春华首页",
    BetterMedicalCare:
      "“优诊通”是春华健康为中国消费者解决就医难、保健难问题而研发的综合型服务产品。为您提供国际、" +
      "国内医疗绿色通道服务，在线和电话医疗咨询，便捷就医，医药咨询指导，国内外医学专家第二诊疗建议，" +
      "癌症筛查及健康保险等服务。根据项目设定不同分为金卡（基础会员）、华夏版和全球版。",
    InternationalReferral:
      "携手世界知名医疗机构，根据患者的病情提出更好的治疗方案，通过先进的医疗设备和技术、更早使用先进药物提高治愈率，" +
      "带给患者多一份希望。其次还为您提供就医便捷服务，如陪诊、医疗签证辅助、病历翻译、接送服务、药品咨询等。",
    BetterHealthInsuranceCare:
      "在健康保险第三方管理领域创立“康保通”品牌，为国内外的保险公司、再保险公司、保险经纪公司、保险代理机构、" +
      "和银行等大型企业用户提供健康险第三方管理服务、直付医疗网络、企业团体健康管理等服务。",
    LongDistanceMedicalConsultation:
      "为患者寻求科学全面的第二诊疗意见。针对患者病例为其找到全球知名专科医学专家进行远程会诊，" +
      "打破语言、地域限制，对患者病情做进一步研究，并提出治疗意见。",
    noWait: "看病不再等",
    noExpensive: "降低医疗费用",
    noHard: "就医不再难",
    betterTreatment: "更好的治疗方案", //获得更好的治疗方案
    thirty: "30+个",
    tenThousand: "10000+家",
    oneThousandSeven: "1700+家",
    threeThousand: "3000+位",
    nationalRegion: "国家和地区",
    medicalInstitution: "全球医疗机构",
    domesticHospital: "国内医院",
    medicalExperts: "各学科医学专家",
    more: "更多服务",
    // 我们的服务
    ourServices: {
      expertsOutpatient: "专家门诊预约", // 专家门诊
      expertsOutpatientDetail:
        "预约国际知名医疗机构和国内三甲医院副主任(含)级以上医疗专家门诊。国内医院1-3个工作日回复预约结果，国际医院最快7个工作日回复预约结果。",
      expertsOperation: "预约专家手术", // 专家手术
      expertsOperationDetail:
        "预约国际知名医疗机构和国内三甲医院副主任(含)级以上医疗专家为患者进行手术。国内医院1-7个工作日回复预约结果，一般1-10个工作日内安排手术和住院，国际医院最快7个工作日回复预约结果。",
      expertWard: "专家病房预约", // 专家病房
      expertWardDetail:
        "在优诊通服务网络范围内的国际知名医疗机构和国内三甲医院就诊的患者，优先安排入住专家病房。国内医院1-7个工作日回复预约结果，一般1-10个工作日内住院，国际医院最快7个工作日回复预约结果。",
      longDistance: "远程会诊", // 远程会诊
      longDistanceDetail:
        "预约国际知名医疗机构和国内三甲医院副主任(含)级以上医疗专家为患者进行远程视频或电话会诊。获取权威的第二诊疗意见和更合理的治疗方案。",
      internationalMedical: "国际转诊", // 国际转诊
      internationalMedicalDetail:
        "在全球范围为患者匹配合适的医疗资源，并安排患者前往医疗发达国家的知名医疗机构进行治疗。通过先进的医疗设备及技术提升治愈率。",
      HealthInsurance: "健康保险", // 健康保险
      HealthInsuranceDetail:
        "慧择保险顾问做您的私人保险顾问，为您制定个性化的投保方案；优诊通为您预留2000-20000元不等的保险基金，在您购买保险后一次性返还。帮您有效降低医疗费用，告别因病致贫。",
      cancerScreening: "癌症筛查", // 癌症筛查
      cancerScreeningDetail:
        "为您定制多种体检方案，可有效排查多种恶性肿瘤风险，及早发现癌症隐患。",
      geneTesting: "基因检测", // 基因检测
      geneTestingDetail:
        "全面检测和评估心脑血管疾病、代谢性疾病、免疫相关疾病、家族性疾病的隐性携带者状态等，让您更了解自己的患病风险及家族病史等因素，从而有针对性地进行健康管理。"
    }
  },
  BetterMedicalCare: {
    name: "优诊通",
    aboutBMC: "关于优诊通",
    BMCDetail:
      " “优诊通”是CHG INC.为中国消费者解决就医难、保健难问题而研发的综合型服务产品，“优诊通”有效整合了包括美国梅奥诊所、日本癌研有明癌症医院和国内保健协和医院、解放军总医院、上海华山医院等全球超过3000家知名医疗资源" +
      "和包括慈铭体检、慧择保险等健康服务机构为用户提供一站式健康解决方案和名医大院就诊问题。为您提供国际、国内医疗绿色通道服务，" +
      "在线和电话医疗咨询，就医陪诊，医药咨询指导，国内外医学专家第二诊疗意见，癌症筛查及健康保险等服务。",
    ThereAreThree: "根据项目设定不同分为金卡（基础会员）、华夏版和全球版。",
    moreEfficient: "更高效便捷的服务体验",
    widerMedical: "更宽领域的医疗服务范围",
    moreAffordable: "更高性价比的就医模式",
    advantages: "优诊通的优势",
    hospitalsNumber: "覆盖医院数量",
    hospitalsNumberDetail:
      "覆盖国内包含三甲医院在内的1700多家医院（含港澳台）。覆盖全球超过3000家知名医疗机构。",
    serviceRange: "区域范围及医生资源",
    serviceRangeDetail:
      "服务网点覆盖全球超过30个国家和地区，国内医院网络覆盖全国省会及重点城市100余座。在全球拥有超过3000位各学科医学专家资源。",
    serviceHours: "服务时间",
    serviceHoursDetail: "为客户提供365*24小时的全天候真挚服务。",
    respondEfficiency: "响应速度",
    respondEfficiencyDetail:
      "最快60秒内极速回复，客服平均响应时间不超过10分钟。",
    OurCooperation: "携手合作",
    OurCooperationDetail:
      "与慈铭体检、慧择保险、记健康等健康服务机构及世界知名医院紧密合作。",
    oneStop: "一站式服务",
    oneStopDetail:
      "打造高效率、高质量、高性价比、全方位的全新就医方式和个性化的健康服务体验，为您和家人的健康保驾护航。",

    // 会员中心
    memberSystem: "会员体系",
    memberCenter: "会员中心",
    vipBasic: "金卡（基础会员）", // 基础版
    vipChinese: "华夏版会员", // 华夏版
    vipGlobal: "全球版会员", // 全球版
    benefitFourFamily: "让贴心的健康服务惠及全家",
    instructions: "会员使用说明：",
    // 1,2,3,4
    instructionsFirst: "1、金卡（基础会员）年费3000/年，期满后可续费。",
    instructionsSecond:
      "2、本年度有效期内，会员及直系亲属（父母、子女、配偶）若需要使用华夏版和全球版的更多服务项目，可按市场价格享受7折优惠。（保险产品除外）",
    instructionsThird:
      "3、金卡（基础会员）年度有效期内升级华夏版赠送1年金卡（基础会员）；升级全球版赠送2年金卡（基础会员）。",
    instructionsFourth:
      " 4、赠送的会员权益在升级的华夏版或全球版有效期结束后自送生效，不可折现及转赠他人。",

    // 我们的服务
    ourService: "我们的服务",
    expertOutpatient: "专家门诊预约",
    expertOutpatientDetail:
      "在优诊通服务网络覆盖范围内，为您预约世界知名医疗机构的各学科医学专家和国内三甲医院副主任级（含）以上专家门诊，用户可指定医院及科室。" +
      "客服在收到您的挂号需求起24小时内联系您确认需求，国内医院1-3个工作日内通知您预约结果，一般情况下1-7个工作日内安排就诊。（特殊情况另行商议调整）",
    expertOperation: "专家手术预约",
    expertOperationDetail:
      "在优诊通服务网络覆盖范围内，为您预约世界知名医疗机构的各学科医学专家及国内三甲医院副主任级（含）以上专家手术，用户可指定医院及科室。" +
      "您提交需求后，客服会在24小时内联系您确认需求，国内医院1-7个工作日内通知您预约结果，一般情况下1-10个工作日内安排手术和住院。（特殊情况另行商议调整）",
    expertWard: "专家病房预约",
    expertWardDetail:
      "在优诊通服务网络覆盖范围内，为您协调优先安排入住专家病房。您提交需求后，" +
      "客服会在24小时内联系您确认需求，国内医院1-7个工作日内通知您预约结果，一般情况下1-10个工作日内安排住院。（特殊情况另行商议调整）",
    expertRecommendation: "专家推荐",
    expertRecommendationDetail:
      "权威医院和专家推荐（含药品咨询），春华健康拥有3000多家全球知名医疗机构资源，为患者推荐国内外在该方面权威的医院和专家，减少就医波折。" +
      "同时为您提供国际、国内新药特药咨询推荐，提升治愈率。",
    sevenDays: "（国际医院最快可在7日内回复预约结果）",
    chineseHospital: "优诊通华夏版医院列表", // 华夏版医院列表
    globalHospital: "优诊通全球版医院列表", // 全球版医院列表

    // 远程会诊项目服务
    longDistance: "远程会诊项目服务",
    pathologicalConsultation: "病理咨询", // 病理咨询
    imagingConsultation: "影像咨询 ", // 影像咨询
    // expertRecommendation: "专家推荐" // 专家推荐
    materialCollection: "材料收集", // 材料收集
    appointmentConfirmation: "确认预约", // 确认预约
    longMedical: "远程医疗咨询", // 远程医疗咨询
    outpatientReport: "会诊报告", // 会诊报告
    followUpService: "后续服务", // 后续服务
    serviceIntroduction: "服务介绍",
    // 服务介绍详情
    introduceContent:
      "为患者寻求科学全面的第二诊疗意见，打破语言、地域限制，针对患者病例为其找到在该方面权威的专科医学专家，" +
      "利用现代化工具，通过远程视频、电话等形式对患者的病情做进一步研究，并提出治疗建议，供患者和主治医生参考。",
    introduceContentFirst:
      "1、华夏版可预约国内三甲级医院的副主任医师（含）及以上级别的医学专家进行远程电话会诊，单次问诊时间不少于20分钟。",
    introduceContentSecond:
      "2、全球版可预约国际知名医疗机构医学专家视频会诊，单次会诊时间不少于30分钟。",

    // 癌症筛查
    cancerScreening: "癌症筛查",
    cancerScreeningDetailTop:
      "随着人的年龄增长及全球环境恶化，恶性肿瘤发病率逐年增加，根据2017世卫组织公布数据表明，每年约有1400万新发癌症病例，每年有800万人死于癌症" +
      "许多患者由于检查不及时，诊断过晚，直接导致治愈率大幅下降，希望渺茫。医学研究表明，至少有20种以上的癌症，" +
      "是可以根据提早预防、合理治疗有效延长患者生命，提高患者生存质量，甚至治愈。",
    cancerScreeningDetailBottom:
      "（华夏版）癌症筛查体检套餐，该体检套餐检查项共40余大项200余小项，全面排查常见慢性病、" +
      "及心脑血管方面和肿瘤方面基本筛查；和更高端的（全球版）癌症筛查体检套餐，检查项共50余大项200小项，" +
      "可深度排查早期肿瘤，评估全身健康状况，以及国际定制体检服务，全球版用户可前往美国（梅奥）及日本（癌研有明）" +
      "等世界知名医疗机构进行定制体检，带给您不一样的服务体验。",
    notes: "注：",
    psFirst:
      "1、全球版用户可在国内（限北京）高端癌症筛查和国际定制癌症筛查两项中任选一项进行体检。",
    psSecond:
      "2、国际医疗机构体检机制不同，医院专家根据您的身体健康状况定制体检方案，故产生的体检费用不同，优诊通为全球版用户负担最高40000元海外体检费用。" +
      "国内高端癌症筛查套餐价格为22205元，包含奥亚医院独立房间免费使用24小时，以及营养师打造五星级自助餐等服务。（提供的国内与国际筛查项目存在差价，均不变现不返还）",
    psThird:
      "3、全球版用户前往北京或海外进行体检时产生的额外费用（如交通费、住宿费、购物费等）体检项目外费用，需用户自理。",
    physicalExamination: "体检项目明细", // 体检项目明细
    physicalExaminationLocation: "体检地点",

    // 健康保险
    healthInsurance: "健康保险",
    insuranceConsultants: "慧择保险顾问", // 慧择保险顾问
    insuranceConsultantsDetail:
      "国家认证理财规划师5年从业经验，保险、理财、税务、医疗、法律知识全面覆盖。",
    characterized: "量身定制保险方案", // 量身订造
    characterizedDetail: "根据家庭不同因素定制方案。",
    iPay: "您消费，我买单！",
    iPayDetail: "凡在慧择网购买保险的会员，我们将为您定额减免保费。",
    huizeDetail1:
      "深圳市慧择保险经纪有限公司，2006年正式成立，是经保监会批准最早获得保险网销资格的网站之一，" +
      "是第三方互联网保险服务平台的创立者。经过12年的发展，慧择网已与80余家保险公司合作，提供近千款保险产品服务，" +
      "产品线涵盖了健康险、人寿险、意外险、旅游险、企业险等全险种产品， 服务用户超过3000万。",
    huizeDetail2:
      "目前，国内医疗消费一直处于较高水平，中产家庭因病致贫的案例屡见不鲜，为了让您在享受优质医疗服务的同时最大限度的降低医疗费用，" +
      "优诊通携手慧择网为您提供健康保险服务。此项服务涵盖“保险顾问”及“保险基金”两大模块。" +
      "“保险顾问”是由春华健康合作伙伴慧择保险网提供的专业保险师咨询服务，为您量身定制保险投保方案， 用合理投资为健康护航。" +
      "“保险基金”是指在您激活优诊通产品后，即享有由春华健康为您预留的保险基金一份（华夏版为2000元，全球版为20000元），" +
      "在您从慧择网购买保险并确认保单生效且在30天犹豫期过后未退保，保险基金将以转账形式一次性转入到您预留的银行账户中。",
    beCarefulFirst: "1. 保险基金为购买保险专项费用，额度固定，不可折现。",
    beCarefulSecond:
      "2. 若您购买的保险费用低于保险基金额度，可根据您的实际需求组合购买其他保险产品。",
    beCarefulThird:
      "3. 若您购买的保险费用高于保险基金额度上限，超出部分需由您本人承担。",
    beCarefulFourth:
      "4. 从卡片激活起，保险基金有效期为1年 且保险基金只供客户首年保费使用。",

    // 基因检测
    geneticTesting: "基因检测",
    geneDetection1: "完整解读基因密码，精准管理健康人生!",
    geneDetection2:
      "基因作为人类最重要的遗传密码，决定了人类的遗传变异特性。大多数恶性肿瘤，心脑血管及家族性疾病都在基因排序中有所呈现。" +
      "春华健康联手国内最前沿的医疗产品研发机构记健康为您量身订制一款全面检测套餐，让您更了解自己身体的患病风险、家庭遗传病史等因素。",
    detailsTesting: "检测项目明细",

    // 更多专享服务
    moreExclusiveServices: "更多专享服务",
    accompanyDuring: "全程陪诊", // 全程陪着
    accompanyDuringDetail:
      "在您就医的过程中，有专业人员全程陪同，对您进行一对一就诊指导。内容包含：诊前咨询、就诊注意事项提醒、科室及就诊流程介绍、线路引导、挂号及科室排队、辅助病情描述。（限北京、上海）",
    psychologicalCounseling: "心理咨询", // 心理咨询
    psychologicalCounselingDetail:
      "持证心理专家在线咨询，纾解难题，解开迷惑，享受阳光生活。",
    pickUp: "接送服务", // 接送服务
    pickUpDetail:
      "在您前往异地就医时，春华健康还为您提供专车接送及酒店预订等贴心服务。（限北京、上海）",
    takeRecords: "代取病历", // 代取病例
    takeRecordsDetail:
      "当您不在就医医院地区时我们可协助代取病历服务及协助病理邮寄给第二诊疗医院。（限北京、上海）",
    doctorsOnline: "全科医生在线问诊", // 全科医生在线问诊
    doctorsOnlineDetail:
      "来自各大医院的全科医生在线问诊，小毛病，在线问医生。（医生均来自三甲医院）",
    doctorsPhone: "全科医生电话问诊", // 全科医生电话问诊
    doctorsPhoneDetail:
      "来自各大医院的全科医生，7 * 24小时全天候为您服务，父母也能轻松使用健康顾问。（医生均来自三甲医院）",
    nutritionistsOnline: "营养师在线咨询", // 营养师在线
    nutritionistsOnlineDetail:
      "给您更合理的全家营养膳食搭配建议。调整饮食结构，让家人吃得更健康。",
    weightOnline: "体重管理在线咨询", // 体重在线咨询
    weightOnlineDetail: "体重管理，根据您的健康数据量身定制可行性健康管理建议。"
  },
  InternationalReferral: {
    name: "蓝十医旅",
    whyAbroad: "为什么要海外就医?",
    famousExperts: "知名医学专家",
    topRankedHospitals: "排名顶级医院",
    latestMedicalTechnology: "最新医疗技术",
    highSurvival: "癌症生存率高",
    newMedicine: "新药率先上市",
    advancedEquipment: "先进仪器设备",

    // 我们的优势
    ourAdvantages: "我们的优势",
    ourAdvantagesDetail:
      "CHG 拥有成熟的海外团队和资源网络，可以帮您实现高效便捷地海外就医，并享受部分医疗及药品费用减免。" +
      "我们的服务网点覆盖全球超过30个国家和地区，与包含世界知名医院在内的超过1万家医疗机构和近100万家药房建立了深度合作。",
    efficient: "高效", // 高效
    healthy: "健康", // 健康
    safe: "安全", // 安全
    economical: "节约", // 节约
    guaranteed: "保障", // 保障

    // 发达国家医疗特点
    medicalParticularity: "发达国家的医疗特点",
    US: {
      name: "美国",
      topWorld: "综合医疗实力全球领先",
      topFive: "癌症五年生存率全球领先",
      topDeveloping: "新药开发能力全球领先",
      medicalSystem: "医疗服务体系成熟",
      advancedTechnology: "医疗技术先进"
    },
    Japan: {
      name: "日本",
      lowerCost: "同等医疗条件医疗费用低",
      technologySystem: "医疗技术体系成熟",
      closeChina: "距中国近 交通方便",
      excellentServices: "医疗服务优越",
      efficientMedical: "医疗模式高效 服务全面"
    }
  },
  About: {
    name: "关于我们",
    chg: "春华健康（CHG）简介",
    chgDetail1:
      "CHG是一家秉承着“客户至上" +
      "正义卓越”的价值宗旨，整合全球优质医疗健康资源，服务保险企业和保险用户的专业第三方健康管理和" +
      "医疗旅行服务企业。“成为您最信赖的健康管理伙伴”是CHG努力前行的美好愿景。CHG目前仅在美国和中国已经建成的医疗和药品服务网络覆盖中美8000多家医院、超过70万家药房、120万名以上的医生服务团队；其中包括了梅奥诊所" +
      "、克利夫兰诊所、哈佛大学麻省总医院等多数排名前100位的医疗机构以及国内北京协和医院、上海华山医院、中日友好医院、解放军总医院等知名三甲医院。",
    chgDetail2:
      "CHG在北京、上海、深圳、合肥、美国休斯顿、纽约和日本东京设立有办公室，提供包括医疗TPA、健康保险产品经纪业务、国际转诊、" +
      "医疗签证辅助、病历资料翻译、第二诊疗意见、医院和专家预约、全程陪诊、衣食住行安排等全方位服务。",
    companyCulture: "公司文化",
    ourValue: "价值观：",
    ourValueDetail: "客户至上 正义卓越",
    ourMission: "使  命：",
    ourMissionDetail: "爱与科技 守护健康",
    ourWish: "愿  景：",
    ourWishDetail: "成为您最信赖的健康伙伴",
    contactUs: "联系我们",
    chinaAddress: "中国各办公室地址",
    hefei: "合肥市高新区创新大道 2688号中新大厦11层 邮编230088",
    beijing: "北京市北京经济技术开发区荣华南路君安国际6栋 邮编：100076",
    shanghai: "上海市虹口区东大名路501号白玉兰广场23层 邮编：200080",
    shenzhen: "深圳市南山区南海大道粤海路深圳动漫园3-4栋5F 邮编：518054",
    usaAddress: "美国各办公室地址",
    usaAddress1: "233 Broadway Suite 2200，New York，NY 10279",
    usaAddress2: "7707 Fannin St Houston, TX 77054",
    japanAddress: "日本办公室地址",
    japanAddress1: "东京都丰岛区西池袋5-17-12 创业新干线大厦2楼"
  },
  Recruit: {
    name: "人才招聘",
    joinUs: "人才招聘",
    welcomeYou: "春华健康欢迎您的加入",
    welcomeYouDetail1:
      "爱、卓越、责任、创新、团队合作、正直是我们春华人的精神。我们在中国发展迅速，现在我们诚邀有合作精神愿意接受有挑战性的工作并拥有相关工作经验的有识之士加入我们的团队。我们将提供好的职业发展机会和根据员工对公司所做贡献而有竞争力的薪酬福利。",
    welcomeYouDetail2:
      '查看下方我们最新提供的职位，如需申请，请将您的中英文简历和薪资期望发送至：<span style="color:#479AED; cursor: pointer;" class="email">chg@chunhuahealth.com</span>邮箱，我们会及时回复您，谢谢！'
  },
  openMember: {
    scanCode: "（扫码联系客服）",
    limitedTime: "金卡（基础会员）限时专享",
    healthInsurance: "健康保险",
    accompanyDuring: "陪诊服务",
    leftDetail:
      "目前，国内医疗消费一直处于较高水平，中产家庭因病致贫的案例屡见不鲜为了让您在享受优质医疗服务的同时最大限度的降低医疗费用，春华健康及服务伙伴慧择网为您提供价值500元/半年的一对一专业保险师咨询服务，" +
      '合理投资为健康护航，并能得到一份500元的保险基金，您消费我买单！以及一次1000元的陪诊服务，在您就医的过程中，有专业人员全程陪同，对您进行一对一就诊指导。限时专享包总价值2000元。',
    psychologicalCounseling: "心理咨询",
    cancerScreening: "癌症筛查",
    rightDetail:
      "可获得持证专家为您在线解决疑难问题、心理疏导沟通健康的专享服务共两次，总价值400元。春华健康及服务伙伴慈铭体检为您量身打造一套癌症筛查体检套餐，价值1600元" +
      "排查常见慢性病及心脑血管方面和肿瘤方面的基本筛查，评估健康状况，提升健康品质。限时专享包总价值2000元。",
    serviceList: "基础会员服务列表",
    makeAppointment: "预约挂号", //预约挂号
    makeAppointmentDetail:
      "覆盖全国1700多家医院的就医绿色通道 ，优先预约专家，快速就医。",
    recommendingExperts: "专家推荐", // 专家推荐
    recommendingExpertsDetail:
      "根据病情为您推荐全球最适合的医院和专家，以及药品咨询。",
    consultOnline: "在线问诊", // 在线问诊
    consultOnlineDetail: "来自各大医院的全科医生在线问诊，小毛病，在线问医生。",
    consultPhone: "电话问诊", // 电话问诊
    consultPhoneDetail:
      "来自各大医院的全科医生，7 * 24小时全天候为您服务，父母也能轻松使用健康顾问。",
    weightManagement: "体重管理", // 体重管理
    weightManagementDetail:
      "体重管理，根据您的健康数据量身定制可行性健康管理建议。",
    nutrientConsultation: "营养师咨询", // 营养师咨询
    nutrientConsultationDetail:
      "给您更合理的全家营养膳食搭配建议。调整饮食结构，让家人吃得更健康。"
  },
  BetterHealthInsuranceCare: "康保通",
  LongDistanceMedicalConsultation: "远程会诊",
  ServiceItems: {
    name: "服务项目"
  },
  InformationCenter: {
    name: "信息中心"
  },
  ServiceCase: {
    name: "服务案例"
  },
  NewsInformation: {
    name: "新闻动态"
  },
  top: "回到顶部",
  imgUrl: {
    bmcBanner: require("../images/banner.png"),
    homeBanner3: require("../images/homeimg/banner3.jpg"),
    bmcOurServe: require("../images/active.jpg"),
    bmcHexagon: require("../images/bestMedicalCare/hexagon.png")
  }
};
